export const QA_NAME_ENTITY_TAB_POSTS_SEARCH = 'entityTabPostsSearch'
